import { render, staticRenderFns } from "./tabelaGuiasSelecionadas.vue?vue&type=template&id=381cdfc5"
import script from "./tabelaGuiasSelecionadas.vue?vue&type=script&lang=js"
export * from "./tabelaGuiasSelecionadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports